import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';

import { RoutePathEnum } from '@connect-services/client/models/routes.model';

@Injectable({
    providedIn: 'root',
})
export class NavigationStateService {
    private readonly NAVIGATION_KEY = 'entity_detail_navigated';

    public clearNavigation(): void {
        sessionStorage.removeItem(this.NAVIGATION_KEY);
    }

    public markNavigated(): void {
        sessionStorage.setItem(this.NAVIGATION_KEY, 'true');
    }

    public wasNavigatedTo(): boolean {
        return sessionStorage.getItem(this.NAVIGATION_KEY) === 'true';
    }
}

export const ReloadGuard: CanActivateFn = async (route: ActivatedRouteSnapshot) => {
    const navigationService = inject(NavigationStateService);
    const router = inject(Router);

    const projectId = route.paramMap.get('projectId');

    if (!navigationService.wasNavigatedTo()) {
        if (projectId) {
            await router.navigate([RoutePathEnum.PROJECTS, projectId]);
        }

        await router.navigate([]);

        return false;
    }

    navigationService.clearNavigation();

    return true;
};
